export function Plus(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M20 10c0 .5306-.2108 1.0395-.586 1.4147-.3752.3753-.8841.586-1.4147.586h-5.999V18c0 .5304-.2107 1.0391-.5858 1.4142-.375.3751-.8837.5858-1.4141.5858-.53045 0-1.03915-.2107-1.41421-.5858-.37506-.3751-.58573-.8838-.58573-1.4142v-5.9993H1.9999c-.53041 0-1.03907-.2107-1.414129-.5857C.210712 11.0399 0 10.5312 0 10.0007c0-.53038.210712-1.03908.585771-1.41415.375059-.37508.883719-.5858 1.414129-.5858h6.00056V2.00002c0-.53043.21067-1.039155.58573-1.414228C8.96125.210719 9.46995 0 10.0004 0c.5304 0 1.0391.210719 1.4141.585792.3751.375073.5858.883798.5858 1.414228v5.99924h5.999c.2628 0 .5229.05175.7657.1523.2427.10055.4632.24793.649.43371.1858.18579.3332.40634.4337.64908.1005.24274.1523.50291.1523.76565Z"
      />
    </svg>
  );
}
